import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

/**
 * The single guard for every admin-only page.
 *
 * Pathless — the `_superAdmin` segment adds nothing to the URL, so `/promo-codes`
 * stays `/promo-codes`. Putting a route file in this folder is what makes it
 * admin-only, which is harder to forget than wrapping each component, and
 * `beforeLoad` runs before the route is entered, so its loaders never run for a
 * partner team member.
 *
 * This is convenience, not security. The Firestore rules and the callable
 * functions are what deny the data behind these pages.
 */
export const Route = createFileRoute('/_app/_superAdmin')({
  beforeLoad: ({ context }) => {
    if (context.role.kind !== 'superAdmin') {
      throw redirect({ to: '/' })
    }
  },
  component: () => <Outlet />,
})
